<template>
  <div class="tag_box">
    <div class="person_list_box" ref="person_list_box" :class="{autoHeight:isOpen}">
      <el-tag class="tag" v-for="tag in sendTargets" :key="tag.studentCode" closable type="primary"
        @close="handleClose(tag)">
        {{ tag.studentName }}
      </el-tag>
    </div>
    <div class="show_more_btn" v-show='showMoreBtn' @click="isOpen = !isOpen">
      <span v-if="!isOpen">展示<el-icon><ArrowDown /></el-icon></span>
      <span v-else>收起<el-icon><ArrowUp /></el-icon></span>
    </div>
  </div>

</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
const props = defineProps({
  sendTargets: {
    type: Array,
    default: () => []
  }
})
const person_list_box = ref(null);
const emit = defineEmits(['close'])
const handleClose = (tag) => {
  emit('close', tag)
}
const showMoreBtn = ref(false);
const isOpen = ref(false)
watch(() => props.sendTargets, () => {
  if (props.sendTargets.length == 0) return
  console.log(props.sendTargets)
  nextTick(() => {
    // 渲染时机不太对，不是新数据渲染完成之后执行的 此处暂时使用定时器处理
    setTimeout(() => {
      let height = person_list_box.value.scrollHeight;
      console.log('height', height)
      if (height > 60) {
        showMoreBtn.value = true;
      }
    }, 100)

  })
}, {
  immediate: true
})
</script>

<style lang="less" scoped>
.tag_box {
  position: relative;
  padding-bottom: 20px;

  .person_list_box {
    max-height: 58px;
    overflow: hidden;
    width: 670px;

    .tag {
      margin-right: 5px;
      margin-bottom: 5px
    }
    &.autoHeight{
      max-height: none;
    }
  }

  .show_more_btn {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    color: #333;
    font-size: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    :deep(.el-icon){
      position: relative;
      top:2px;
    }
  }
}
</style>